import React from 'react';

interface TipoInicioSelectorProps {
  tipoInicio: 'contratista' | 'tipoTrabajo';
  onChange: (tipo: 'contratista' | 'tipoTrabajo') => void;
}

export const TipoInicioSelector: React.FC<
  TipoInicioSelectorProps
> = ({ tipoInicio, onChange }) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <div>
              <div className="form-check mb-2">
                <input
                  className="form-check-input"
                  type="radio"
                  name="tipoInicio"
                  id="inicioContratista"
                  value="contratista"
                  checked={tipoInicio === 'contratista'}
                  onChange={(e) =>
                    onChange(
                      e.target.value as 'contratista' | 'tipoTrabajo'
                    )
                  }
                />
                <label
                  className="form-check-label"
                  htmlFor="inicioContratista"
                >
                  Inicio por Contratista
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="tipoInicio"
                  id="inicioTipoTrabajo"
                  value="tipoTrabajo"
                  checked={tipoInicio === 'tipoTrabajo'}
                  onChange={(e) =>
                    onChange(
                      e.target.value as 'contratista' | 'tipoTrabajo'
                    )
                  }
                />
                <label
                  className="form-check-label"
                  htmlFor="inicioTipoTrabajo"
                >
                  Inicio por Tipo de Trabajo
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
